<template>
      <van-divider>尚未查询到已完成的保单</van-divider>
      <van-cell-group inset>
          <van-divider content-position="left"  :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">如果您已经完成支付，请联系我们</van-divider>
          <van-cell center title="邮件" value="lukes@coipor.com" />
          <van-cell center title="电话" value="+(0755) 86703152" label="工作日: 9:00 - 18:00" />
      </van-cell-group>
    <br/>
  </template>
  <script>
  </script>
  <style>
  </style>